import { ServiceMetricsDataCellProps } from '../types';
import { COLUMNS } from '../columns';

const ServiceMetricsTextCell = ({ column, ...props }: ServiceMetricsDataCellProps) => {
  const columnId = typeof column === 'object' ? column.id : column;

  let value: string | number = '';

  switch (columnId) {
    case COLUMNS.TEAM_ID:
      value = props.mosaicTeamId;
      break;
    case COLUMNS.INTEGRATION_ID:
      value = props.targetServiceId;
      break;
    default:
      break;
  }

  return <span>{value}</span>;
};

export default ServiceMetricsTextCell;
